import React, { BaseSyntheticEvent, memo } from 'react';

import { Grid } from '@material-ui/core';
import { ThemeOutlineInput } from '../../../../theming/theme-input/theme-outline-input';
import clsx from 'clsx';
import {
    useFormControlLabelStyles,
    useFormControlStyles,
    useInputStyles,
    useStyle,
} from '../damage-report-form-components-styled';

interface DamageReportFormInputProps {
    value: unknown;
    handleChangeValue: (event: BaseSyntheticEvent) => void;
    label: string;
    name: string;
    disabled?: boolean;
    regexp?: RegExp;
    onBlur?: () => void;
    error?: boolean;
}

export const DamageReportFormInput = memo(
    ({
        value,
        handleChangeValue,
        label,
        name,
        disabled,
        regexp,
        onBlur,
        error,
    }: DamageReportFormInputProps) => {
        const classes = useStyle();
        const formControlClasses = useFormControlStyles();
        const formControlLabelClasses = useFormControlLabelStyles();
        const inputClasses = useInputStyles();
        return (
            <Grid item className={clsx(classes.thirdPart)}>
                <ThemeOutlineInput
                    disabled={disabled}
                    inputClasses={inputClasses}
                    value={value}
                    label={label}
                    formControlLabelClasses={formControlLabelClasses}
                    formControlClasses={formControlClasses}
                    handleChangeValue={handleChangeValue}
                    name={name}
                    regexp={regexp}
                    onBlur={onBlur}
                    error={error}
                />
            </Grid>
        );
    }
);
